<template>
  <main>
    <checkout-view v-if="hasTenantId" :tenantId="hasTenantId"></checkout-view>
    <invalid-tenantId v-else></invalid-tenantId>
  </main>
</template>

<script>
import "@/assets/css/index.css";
import CheckoutView from "./components/CheckoutView";
import InvalidTenantId from "./components/InvalidTenantId";

import { getUrlParameters, validateTenantId } from "@/lib/utils";

let parameters = null;

export default {
  name: "App",
  components: {
    CheckoutView,
    InvalidTenantId
  },
  data() {
    return {
      hasTenantId: null
    };
  },
  mounted() {
    parameters = getUrlParameters(window.location.search);

    const tenantId = parameters.tenantId;

    if (!tenantId || !validateTenantId(tenantId)) {
      return;
    }

    this.hasTenantId = tenantId;
  }
};
</script>


// WEBPACK FOOTER //
// src/App.vue